'use client';

import React__default, { useContext, useRef, useEffect } from 'react';
import { ToolTipWrapper } from './Tooltip.css.js';
import { BarChartContext } from '../../context/reducer.js';

var Tooltip = function (props) {
    var children = props.children, chartRef = props.chartRef;
    var _a = useContext(BarChartContext), barChartState = _a.barChartState, dispatch = _a.dispatch;
    var tooltipRef = useRef(null);
    var calculateXPosition = function (x) {
        if (!tooltipRef.current) {
            return x;
        }
        var windowWidth = window.screen.width;
        var length = windowWidth - x;
        if (length < 200) {
            x = x - 200;
        }
        return x;
    };
    var onMouseClick = function (e) {
        var x = calculateXPosition(e.clientX);
        var y = e.clientY;
        if (chartRef && (chartRef === null || chartRef === void 0 ? void 0 : chartRef.current)) {
            var chartRect = chartRef === null || chartRef === void 0 ? void 0 : chartRef.current.getBoundingClientRect();
            x = x - chartRect.x;
            y = e.clientY - chartRect.y;
        }
        dispatch({
            type: 'UPDATE_TOOLTIP_POSITION',
            payload: {
                x: x,
                y: y
            }
        });
    };
    useEffect(function () {
        if (typeof window === 'undefined') {
            return;
        }
        window.addEventListener('mousemove', onMouseClick);
        window.addEventListener('click', onMouseClick);
        return function () {
            window.removeEventListener('mousemove', onMouseClick);
            window.removeEventListener('click', onMouseClick);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        if (tooltipRef.current === null) {
            return;
        }
        var x = calculateXPosition(barChartState.tooltip.x);
        dispatch({
            type: 'UPDATE_TOOLTIP_POSITION',
            payload: {
                x: x,
                y: barChartState.tooltip.y
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tooltipRef]);
    return (React__default.createElement(ToolTipWrapper, { style: {
            top: barChartState.tooltip.y,
            left: barChartState.tooltip.x + 8
        }, ref: tooltipRef }, children));
};
var Tooltip$1 = React__default.memo(Tooltip);

export { Tooltip$1 as default };
//# sourceMappingURL=index.js.map
